var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodiumThirdStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 80 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7460 (Stroke)",
    d: "M10 5V10H5V62H75V10H70V5H10ZM80 5V61H0V5H5V0H75V5H80Z",
    fill: "url(#paint0_linear_0_32)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_32",
    x1: 21.5,
    y1: 51.5,
    x2: 94.9769,
    y2: 106.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4864D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601874,
    stopColor: "#653B15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodiumThirdStroke);
export default __webpack_public_path__ + "static/media/podium-third-stroke.0018f72c887ea4f96067fc8ca7304c1f.svg";
export { ForwardRef as ReactComponent };